export default "__VITE_ASSET__d7460e31__"